import type { TPlacement } from '@shared/types/placement';
import type { THousingFormValues } from './housing';
import { createThirdStepInitialValues, housingFormSchema } from './housing';
import type { TPlacementFormValues } from './placement';
import { createFirstStepInitialValues, placementFormSchema } from './placement';
import type { TPositionFormValues } from './position';
import { createSecondStepInitialValues, positionFormSchema } from './position';

import { object } from 'yup';

export const createAllStepsInitialValues = (placementData?: TPlacement) => {
  return {
    firstStep: createFirstStepInitialValues(placementData),
    secondStep: createSecondStepInitialValues(placementData),
    thirdStep: createThirdStepInitialValues(placementData),
  };
};

export const allStepsSchema = object().shape({
  firstStep: object().shape(placementFormSchema.fields),
  secondStep: object().shape(positionFormSchema.fields),
  thirdStep: object().shape(housingFormSchema.fields),
});

export type TAllStepsInitialValues = {
  firstStep: TPlacementFormValues;
  secondStep: TPositionFormValues;
  thirdStep: THousingFormValues;
};
